<template>
  <p class="pt16 pb16">
    <base-alert>
      <i class="el-icon-warning"></i>
      <b>图片查重提示：</b>
      *标记任务记录内提交的图片存在重复，请注意查看
    </base-alert>
  </p>
</template>

<script>
import baseAlert from '@C/Base/baseAlert';
export default {
  name: 'ExistRepeatPic',
  components: {
    baseAlert
  }
};
</script>

<style scoped></style>
